<template>
  <div style="padding: 2rem 3rem; text-align: left;">
    <div class="field">
      <label class="label">Código do Cliente</label>
      <div class="control">
        <input class="input" type="text" placeholder="Buscar cliente..." v-model="id" />
        <button @click="fetch">Buscar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
export default {
  props: ["clickedNext", "currentStep"],
  computed: {
    client() {
      return this.$store.getters.client;
    }
  },
  data() {
    return {
      id: ""
    };
  },
  methods: {
    ...mapActions(["fetchClient"]),
    async fetch() {
      if (!Number.isInteger(Number(this.id))) {
        Swal.fire("Ops!", "O código deve ser um número válido.", "error");
        return;
      }

      try {
        await this.fetchClient({ id: this.id });
        this.$emit("can-continue", { value: true });
        Swal.fire("Sucesso!", `Usuário: ${this.client.name}`, "success");
      } catch (e) {
        if (e.response && (e.response.status === 404 || e.response.status === 403)) {
          Swal.fire(
            "Ops!",
            `Usuário com código ${this.id} não encontrado.`,
            "error"
          );
          return;
        }
        Swal.fire("Ops!", "Houve um problema ao buscar o dado.", "error");
      }
    }
  },
  mounted() {
    this.$emit("can-continue", { value: false });
  }
};
</script>

<style scoped>
.control {
  display: flex;
}
.control button {
  background-color: #005663;
  color: #fff;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  padding: 0px 15px;
}
label {
  color: #000;
  font-weight: bold;
}
input {
  width: 30%;
  padding: 15px;
  font-size: 20px;
}
</style>